// extracted by mini-css-extract-plugin
export default {"icon":"User_icon__JUQp1","icon_button":"User_icon_button__1grD1","icon_button_danger":"User_icon_button_danger__Svt-k","icon_button_primary":"User_icon_button_primary__qOCYk"};